const setTokenWithExpiration = (token: string, expirationInMinutes: number) => {
  const now = new Date();
  const expirationDate = new Date(now.getTime() + expirationInMinutes * 60000);

  const tokenData = {
    value: token,
    expiration: expirationDate.toISOString()
  };

  localStorage.setItem("accessToken", JSON.stringify(tokenData));
};

export default setTokenWithExpiration;